import React, {Fragment, useMemo, useState} from "react";
import {
    getStrAccordingToFilterMode,
    QUERY_FORM_FILTER_MODE_PLAIN, QUERY_FORM_FILTER_MODE_TREE
} from "../dataset-builder/modals/components/filterUtils";
import {Button, Card, Col, Row, Input} from "antd";
import {GUTTER_SM, MARGIN_MD, MODAL_WIDTH_LG, MODAL_WIDTH_XL} from "../../../styles/constants";
import {
    QUERY_HEIGHT,
} from "../dataset-builder/modals/components/utils";
import ZoomableHighlightedTextarea from "../../../components/zoomable-highlighted-textarea";
import {convertFilterStrWithSimpleFilterForTimePeriod} from "../../../components/tree-filter/utils";
import EnhancedModal from "../../../components/enhanced-modal";
import TreeFilter from "../../../components/tree-filter";
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import FilterForm from "../../../components/filter-form";
import {getArtefactTripletFromUrn} from "../../../utils/sdmxJson";
import {
    addDataflowPublishingQueryFilterFormBlock, addDataflowPublishingQueryFilterFormCondition,
    changeDataflowPublishingQueryTreeFilterColumnMode,
    changeDataflowPublishingQueryTreeFilterColumnValues,
    changeDataflowPublishingWizardFilterForm, changeDataflowPublishingWizardQueryTreeFilter,
    deleteDataflowPublishingQueryFilterFormBlock, deleteDataflowPublishingQueryFilterFormCondition,
    readDataflowPublishingQueryFilterFormColumnValues,
    readDataflowPublishingQueryFilterFormFilterColumnsValues,
    resetAllDataflowPublishingQueryFilter,
    resetDataflowPublishingQueryFilter,
    resetDataflowPublishingQueryFilterFormColumnValues,
    submitDataflowPublishingWizardQueryFilterModal,
    toggleDataflowPublishingQueryPreview
} from "./actions";
import {clearMappingPreviewMappingSet, getMappingSetPreviewToken} from "../mapping-set/mapping-set-wizard/actions";
import {getSimplifiedFilterObj} from "./utils";
import ModalPreview from "../mapping-set/mapping-set-wizard/components/ModalPreview";


const mapStateToProps = state => {
    return {
        appLanguage: state.app.language,
        dataLanguages: state.config.dataManagement.dataLanguages,
        filter: state.scenes.mappingHandler.dataflowPublishing.filter,
        filterTemp: state.scenes.mappingHandler.dataflowPublishing.filterTemp,
        treeFilter: state.scenes.mappingHandler.dataflowPublishing.treeFilter,
        treeFilterTemp: state.scenes.mappingHandler.dataflowPublishing.treeFilterTemp,
        filterMode: state.scenes.mappingHandler.dataflowPublishing.filterMode,
        dlDataflowTriplet: state.scenes.mappingHandler.dataflowPublishing.dlDataflowTriplet,
        dataflowPreviewToken: state.scenes.mappingHandler.mappingSet.wizard.mappingSetPreviewToken,
        dlDataflowParams: state.scenes.mappingHandler.dataflowPublishing.dlDataflowParams,
        showDataflowPreview: state.scenes.mappingHandler.dataflowPublishing.showDataflowPreview,
        dlSelectedCols: state.scenes.mappingHandler.dataflowPublishing.dlDsdCols,
    }
};

const mapDispatchToProps = dispatch => ({
    onFilterModalSubmit: (treeFilter, filterStr) => dispatch(submitDataflowPublishingWizardQueryFilterModal(treeFilter, filterStr)),
    onFilterReset: () => dispatch(resetDataflowPublishingQueryFilter()),
    onFilterResetAll: () => dispatch(resetAllDataflowPublishingQueryFilter()),
    onFilterChange: fields => dispatch(changeDataflowPublishingWizardFilterForm(fields)),
    onBlockAdd: () => dispatch(addDataflowPublishingQueryFilterFormBlock()),
    onBlockDelete: blockIndex => dispatch(deleteDataflowPublishingQueryFilterFormBlock(blockIndex)),
    onConditionAdd: blockIndex => dispatch(addDataflowPublishingQueryFilterFormCondition(blockIndex)),
    onConditionDelete: (blockIndex, conditionIndex) => dispatch(deleteDataflowPublishingQueryFilterFormCondition(blockIndex, conditionIndex)),
    fetchColumnFilteredValues: (
        colNames,
        dataflowId
    ) => dispatch(readDataflowPublishingQueryFilterFormFilterColumnsValues(colNames, dataflowId)),
    onTreeFilterChange: treeFilter => dispatch(changeDataflowPublishingWizardQueryTreeFilter(treeFilter)),
    onColumnModeChange: (colName, mode) => dispatch(changeDataflowPublishingQueryTreeFilterColumnMode(colName, mode)),
    onColumnValuesChange: (colName, values) => dispatch(changeDataflowPublishingQueryTreeFilterColumnValues(colName, values)),
    fetchColumnValues: ({columnName, dataflowId}) =>
        dispatch(readDataflowPublishingQueryFilterFormColumnValues(columnName, dataflowId)),
    resetColumnValues: columnName =>
        dispatch(resetDataflowPublishingQueryFilterFormColumnValues(columnName)),
    onGetDataflowPreviewToken: (dataflowTriplet, token, filter) => dispatch(getMappingSetPreviewToken(dataflowTriplet.id, dataflowTriplet.agencyID, dataflowTriplet.version, token, 1, filter)),
    togglePreview: (value) => dispatch(toggleDataflowPublishingQueryPreview(value)),
    clearPreview: (dataflowPreviewToken) => dispatch(clearMappingPreviewMappingSet(dataflowPreviewToken)),
});

const QueryDownloadFilters = ({
                                  dlDataflowTriplet,
                                  dlDataflowParams,
                                  t,
                                  onFilterModalSubmit,
                                  filterMode,
                                  filter,
                                  filterTemp,
                                  treeFilter,
                                  treeFilterTemp,
                                  disabled,
                                  onFilterReset,
                                  onFilterResetAll,
                                  onFilterChange,
                                  onBlockAdd,
                                  onBlockDelete,
                                  onConditionAdd,
                                  onConditionDelete,
                                  fetchColumnFilteredValues,
                                  onTreeFilterChange,
                                  onColumnModeChange,
                                  onColumnValuesChange,
                                  fetchColumnValues,
                                  resetColumnValues,
                                  sdmxFilters,
                                  objectColumns,
                                  objectId,
                                  dataflowPreviewToken,
                                  onGetDataflowPreviewToken,
                                  togglePreview,
                                  showDataflowPreview,
                                  clearPreview,
                                  dlSelectedCols
                              }) => {
    const [isFilterQueryModalVisible, setIsFilterQueryModalVisible] = useState(false);
    const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);

    const columns = useMemo(() => {
        let resultColumns; 
        var cols = objectColumns.filter((x)=> dlSelectedCols.includes(x.id));
        if (cols) {
            resultColumns = cols.map(col => ({
                ...col,
                Code: col.id,
                name: col.id,
                codelistCount: 1,
                disabled: false,
                filteredValues: col.filteredValues || [],
                filteredCodelistTree: null,
                values: col.values || [],
                CodelistCode: col.localRepresentation && col.localRepresentation.enumeration ? getArtefactTripletFromUrn(col.localRepresentation.enumeration).id : "",
                fetchValues: () =>
                    fetchColumnValues({
                        columnName: [col.id],
                        dataflowId: `${dlDataflowTriplet.id}+${dlDataflowTriplet.agencyID}+${dlDataflowTriplet.version}`
                    }),
                resetValues: () => resetColumnValues(col.id),
                hasCodelist: false,
            }))
        }

        return resultColumns || [];
    }, [objectColumns, dlSelectedCols]);

    const filterStr = useMemo(() =>
        getStrAccordingToFilterMode(filterMode, filter, treeFilter, columns), [filterMode, filter, treeFilter, columns]);

    const filterTempStr = useMemo(() =>
        getStrAccordingToFilterMode(filterMode, filterTemp, treeFilterTemp, columns), [filterMode, filterTemp, treeFilterTemp, columns]);

    if (!columns) {
        return null;
    }

    return (
        <Fragment>
            <Row type="flex" style={{flexDirection: "column", height: "100%"}}>                
                <Col>
                    <Row type="flex" gutter={GUTTER_SM} justify="space-between">
                        <Col>
                            <Button type="primary" onClick={() => setIsFilterModalVisible(true)}
                                    disabled={(!objectColumns && !!objectId)}
                                    style={{marginRight: MARGIN_MD}}>
                                {t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.editFilter.title')}
                            </Button>
                            <Button onClick={() => onFilterResetAll()}
                                    disabled={(!objectColumns && !!objectId) || (!filterStr && !filterTempStr)}>
                                {t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.clearFilter.title')}
                            </Button>
                        </Col>
                        <Col>
                            <Button onClick={() => {
                                onGetDataflowPreviewToken(dlDataflowTriplet, dataflowPreviewToken, getSimplifiedFilterObj(filterTempStr || filterStr).Filter);
                                togglePreview(true);
                            }} disabled={!objectColumns && !!objectId}
                                    icon="eye">
                                {t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.preview.title')}
                            </Button>
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <div style={{fontFamily: 'monospace', marginTop: MARGIN_MD, height: QUERY_HEIGHT}}>
                        <ZoomableHighlightedTextarea
                            disabled
                            value={convertFilterStrWithSimpleFilterForTimePeriod(filterStr)}
                            modalProps={{bodyStyle: {height: "75vh"}, width: MODAL_WIDTH_XL}}
                        />
                    </div>
                </Col>
            </Row>
            <EnhancedModal
                visible={isFilterModalVisible}
                onCancel={() => setIsFilterModalVisible(false)}
                footer={
                    <div>
                        <Button
                            onClick={() => setIsFilterModalVisible(false)}>{t('commons.buttons.cancel.title')}</Button>
                        <Button
                            type="primary"
                            onClick={() => {
                                onFilterModalSubmit(filterMode === QUERY_FORM_FILTER_MODE_PLAIN
                                        ? filterTemp
                                        : treeFilterTemp,
                                    filterTempStr
                                );
                                setIsFilterModalVisible(false);
                            }}
                        >
                            {t('commons.buttons.confirm.title')}
                        </Button>
                    </div>
                }
                width={MODAL_WIDTH_LG}
                title={t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.filterModal.title')}
            >
                <EnhancedModal
                    visible={isFilterQueryModalVisible}
                    onCancel={() => setIsFilterQueryModalVisible(false)}
                    footer={<Button
                        onClick={() => setIsFilterQueryModalVisible(false)}>{t('commons.buttons.close.title')}</Button>}
                    width={MODAL_WIDTH_LG}
                    title={t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.filterQueryModal.title')}
                >
                    <div style={{fontFamily: 'monospace'}}>
                        <Input.TextArea
                            disabled
                            value={convertFilterStrWithSimpleFilterForTimePeriod(filterTempStr)}
                            style={{
                                overflow: 'auto',
                                resize: 'none',
                                height: 560
                            }}
                        />
                    </div>
                </EnhancedModal>
                <Row type="flex" justify="space-between" style={{marginBottom: MARGIN_MD}}>
                    <Col></Col>
                    <Col>
                        <Row type="flex" gutter={GUTTER_SM}>
                            <Col>
                                <Button icon="code" onClick={() => setIsFilterQueryModalVisible(true)}>
                                    {t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.showQuery.title')}
                                </Button>
                            </Col>
                            <Col>
                                <Button icon="delete" onClick={onFilterReset} disabled={disabled}>
                                    {t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.resetFilter.title')}
                                </Button>
                            </Col>
                            <Col>
                                <Button onClick={() => {
                                    onGetDataflowPreviewToken(dlDataflowTriplet, dataflowPreviewToken, getSimplifiedFilterObj(filterTempStr || filterStr).Filter);
                                    togglePreview(true)
                                }}
                                        disabled={!objectColumns}
                                        icon="eye">
                                    {t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.preview.title')}
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {
                    filterMode === QUERY_FORM_FILTER_MODE_PLAIN && (
                        <Card bodyStyle={{height: 396, overflow: "auto"}}>
                            <FilterForm
                                filter={filterTemp}
                                columns={columns}
                                onChange={onFilterChange}
                                onBlockAdd={onBlockAdd}
                                onBlockDelete={onBlockDelete}
                                onBlockConditionAdd={onConditionAdd}
                                onBlockConditionDelete={onConditionDelete}
                                disabled={disabled}
                            />
                        </Card>
                    )}
                {filterMode === QUERY_FORM_FILTER_MODE_TREE && (
                    <div className="query__tree-filter">
                        <TreeFilter
                            disabled={disabled}
                            columns={columns}
                            fetchColumnFilteredValues={({colNames, filterStr}) =>
                                fetchColumnFilteredValues(colNames, `${dlDataflowTriplet.id}+${dlDataflowTriplet.agencyID}+${dlDataflowTriplet.version}`)}
                            onChange={onTreeFilterChange}
                            treeFilter={treeFilterTemp}
                            onColumnModeChange={onColumnModeChange}
                            onColumnValuesChange={onColumnValuesChange}
                            hideInclusionRadio={true}
                            isSdmx={sdmxFilters}
                            isDdbDataflow={true}
                            skipCheckNextColumn={false}
                        />
                    </div>
                )}
            </EnhancedModal>
            <ModalPreview isRowsModalVisible={isFilterModalVisible && showDataflowPreview}
                          onRowsModalHide={() => {
                              togglePreview(false);
                              clearPreview(dataflowPreviewToken);
                          }}
                          dataflowTriplet={dlDataflowTriplet}
                          token={dataflowPreviewToken}
                          dataflowParams={dlDataflowParams}
            />
        </Fragment>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(QueryDownloadFilters);
